import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import OilsRitual from './components/OilsRitual';
import Booking from './components/Booking';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App" data-testid="app">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Testimonials />
        <OilsRitual />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}

export default App;